import { Cache } from "@escapio/portal/state/Cache";

const SECURE_SESSION_ID_KEY = "esc-sec-id";
const TTL = 24 * 60 * 60 * 1000;
const cache = new Cache(SECURE_SESSION_ID_KEY, TTL);
cache.gc();

let secureSessionId = null;

/**
 * Notice: this session id should only contain hex characters.
 * This will be validated by the price controller.
 * When logic is changed, the validation should also be changed accordingly.
 * @see CustomerClientDataFactory
 */
export function getSecureSessionId() {
	if (!secureSessionId) {
		secureSessionId = cache.get(SECURE_SESSION_ID_KEY);
	}
	if (!secureSessionId) {
		secureSessionId = "";
		while (secureSessionId.length < 32) {
			const randomHex = Math.random().toString(16);
			secureSessionId += randomHex.slice(randomHex.lastIndexOf(".") + 1);
			secureSessionId = secureSessionId.slice(0, 32);
		}
		cache.set(SECURE_SESSION_ID_KEY, secureSessionId);
	}
	return secureSessionId;
}
